export default {
    shipperGroup: {
        overview: "Panoramica e AI",
        operations: "Operativo",
        coordination: "Inbox e anomalie",
        commercial: "Commerciale",
        network: "Contatti e rete",
    },
    askEve: "Ask Eve",
    askEveHelpPopover: "Hai bisogno di aiuto?",
    askEveHelpDismiss: "Chiudi",
    controlHub: "Control Hub",
    dashboard: "Dashboard",
    calendar: "Calendario",
    containers: "Container",
    activity: "Activity",
    issues: "Issues",
    quotes: "Preventivi",
    orders: "Ordini",
    receivers: "Partner Commerciali",
    businessPartners: "Partner Commerciali",
    shippers: "Spedizionieri",
    team: "Team",
    addressBook: "Address Book",
    settings: "Impostazioni",
    companies: "Aziende",
    documents: "Documenti",
    eveDrive: "Eve Drive",
    liveTracking: "Live Tracking",
    workflows: "Workflow",
    knowledgeBase: "Knowledge Base",
    analytics: "Analytics",
    support: "Supporto",
    logout: "Logout",
    reviewCenter: "Centro Revisione",
    unreadNotifications: "{{count}} notifiche non lette",
};
